import React from "react";
import { Clock } from "lucide-react";
import VendorLayout from "@/components/vendor_portal/VendorLayout";

/**
 * Reusable "Coming Soon" placeholder for every non-dashboard vendor route
 * (Requests, Catalog, Orders, Messages, Analytics, Settings). Per Prompt 3
 * the functionality is deferred — but the routes must exist so navigation
 * doesn't 404 for approved vendors landing on their portal for the first time.
 */
export default function VendorPlaceholderPage({ title }) {
  return (
    <VendorLayout>
      <section data-testid={`vendor-placeholder-${title.toLowerCase()}`}>
        <div className="text-[12px] uppercase tracking-[0.28em] font-semibold text-[#B59A5A]">
          {title}
        </div>
        <h1 className="font-serif text-4xl sm:text-5xl text-[#1A422D] mt-3">
          {title} — coming soon.
        </h1>

        <div className="mt-8 p-10 bg-white border border-[#E5E3D8] max-w-2xl">
          <div className="w-12 h-12 flex items-center justify-center bg-[#D9C68A]/25 text-[#8A6A2A]">
            <Clock size={22} />
          </div>
          <p className="mt-6 text-[#4A4A4A] leading-relaxed">
            The <strong>{title}</strong> workspace is under construction. We&rsquo;re rolling out vendor tools in phases so every release is polished. You&rsquo;ll receive an email the moment this section opens.
          </p>
          <p className="mt-3 text-sm text-[#7A7A7A]">
            In the meantime, our team may reach out with private-club buying requests directly via email.
          </p>
        </div>
      </section>
    </VendorLayout>
  );
}
